function r(t) {
  return parseInt(t, 16) || 0;
}
function e(t) {
  return r(t) / 255 <= 0.03928 ? r(t) / 255 / 12.92 : Math.pow((r(t) / 255 + 0.055) / 1.055, 2.4);
}
function f(t) {
  return 0.2126 * e(t.substr(1, 2)) + 0.7152 * e(t.substr(3, 2)) + 0.0722 * e(t.substr(-2));
}
function c(t, s) {
  const n = f(t), a = f(s);
  return (Math.max(n, a) + 0.05) / (Math.min(n, a) + 0.05);
}
const u = "#ffffff", o = "#000000", i = "#ffffff33", h = "#00000033";
function g(t) {
  const s = c(t, u), n = c(t, o);
  return s > n ? u : o;
}
const b = (t) => {
  const s = c(t, i), n = c(t, h);
  return s > n ? i : h;
}, k = (t) => g(t) === o;
export {
  b as getBorderColor,
  g as getTextColor,
  k as isBlackContrast
};
